<template>
  <page-container title="People">
    <v-row class="ma-0 mb-2 pa-2 header" align-content="center">
      <v-tabs v-model="selectedTab" height="36">
        <v-tab :to="{ name: 'workforce' }">Workforce</v-tab>
        <v-tab :to="{ name: 'contractors' }">Contractors</v-tab>
        <v-spacer></v-spacer>
        <search-field></search-field>
        <feature name="people" variant="write" :data="this.$route.name">
          <v-btn
            color="primary"
            class="text-none button"
            tile
            @click.prevent="showNewTableItemPopup"
            >{{ actionTitle }}</v-btn
          >
        </feature>
      </v-tabs>
    </v-row>
    <router-view></router-view>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import SearchField from '@/components/SearchField.vue'
import { mapActions } from 'vuex'

export default {
  name: 'People',
  components: {
    PageContainer,
    SearchField,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  computed: {
    actionTitle() {
      return this.$route.name === 'workforce'
        ? 'New employee'
        : 'New contractor'
    },
  },
  methods: {
    ...mapActions(['showNewTableItemPopup']),
  },
}
</script>

<style lang="sass" scoped>
.header
  background-color: $foreground
  height: 58px
</style>
